export const fileUploadStyles = {
  container: {
    width: "100%",
    padding: "20px",
    border: "2px dashed #ccc",
    borderRadius: "8px",
    textAlign: "center",
    backgroundColor: "#f8f8f8",
  },
  label: {
    cursor: "pointer",
    display: "block",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#F6C079",
    color: "#000000",
    borderRadius: "4px",
    display: "inline-block",
    transition: "background-color 0.3s",
  },
  fileInfo: {
    marginTop: "10px",
    padding: "10px",
    backgroundColor: "#fff",
    borderRadius: "4px",
    border: "1px solid #eee",
  },
  preview: {
    marginTop: "15px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    overflow: "hidden",
  },
  error: {
    color: "red",
    marginTop: "4px",
    fontSize: "14px",
  },
}; 